import { initialiseFreshdesk, shutdownFreshdesk } from "./freshdesk";

export const initialiseSupport = (options: {
  userId: string;
  name?: string;
  email?: string;
  createdAt?: number;
}) => {
  initialiseFreshdesk(options);
};

export const shutdownSupport = () => {
  shutdownFreshdesk();
};
